"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _Button = _interopRequireDefault(require("./Button"));
require("../Spinner/themes/DefaultTheme.css");
var SpinnerDefaultTheme = {
  "spin": "DefaultTheme__spin___2BLHD",
  "spinner": "DefaultTheme__spinner___1ZqfV",
  "s": "DefaultTheme__s___1Ezcf",
  "m": "DefaultTheme__m___FFO2l",
  "l": "DefaultTheme__l___3u_d-"
};
require("../Spinner/themes/DarkTheme.css");
var SpinnerDarkTheme = {
  "spinner": "DarkTheme__spinner___3yNHB",
  "s": "DarkTheme__s___1X_Gq",
  "m": "DarkTheme__m___1T7UJ",
  "l": "DarkTheme__l___3zdVO"
}; // themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "button": "DefaultTheme__button___29mtS",
  "primary": "DefaultTheme__primary___249es",
  "neutral": "DefaultTheme__neutral___3ZBg8",
  "no-fill": "DefaultTheme__no-fill___1Pw4q",
  "secondary": "DefaultTheme__secondary___1JUnQ",
  "tertiary": "DefaultTheme__tertiary___3cLHz",
  "flat": "DefaultTheme__flat___1g85K",
  "danger": "DefaultTheme__danger___hdJjA",
  "inverse": "DefaultTheme__inverse___i4aAH",
  "sm": "DefaultTheme__sm___IcJN8",
  "spinner": "DefaultTheme__spinner___1NECm",
  "md": "DefaultTheme__md___1s5qL",
  "lg": "DefaultTheme__lg___o_Th1",
  "circular": "DefaultTheme__circular___3nFPO",
  "is-loading": "DefaultTheme__is-loading___z_iqy",
  "children": "DefaultTheme__children___WfQFi",
  "noFill": "DefaultTheme__no-fill___1Pw4q",
  "isLoading": "DefaultTheme__is-loading___z_iqy"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "button": "DarkTheme__button___2kIdG",
  "disabled": "DarkTheme__disabled___1M4kT",
  "no-fill": "DarkTheme__no-fill___2QrWc",
  "primary": "DarkTheme__primary___3Uk1Z",
  "secondary": "DarkTheme__secondary___2kdte",
  "tertiary": "DarkTheme__tertiary___2Ictb",
  "flat": "DarkTheme__flat___Z46o6",
  "danger": "DarkTheme__danger___38aEz",
  "noFill": "DarkTheme__no-fill___2QrWc"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "button": "LumeTheme__button___2d3zl"
};
DefaultTheme.Spinner = SpinnerDefaultTheme;
DarkTheme.Spinner = SpinnerDarkTheme;
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_Button["default"].displayName, themes.DefaultTheme)(_Button["default"]);
ThemedComponent.displayName = _Button["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map